var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "delete_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".delete_svg__st0{fill:#999}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M428 401.2c-14.4 0-26 11.6-26 26v273.4c0 14.4 11.6 26 26 26s26-11.6 26-26V427.2c0-14.4-11.6-26-26-26zM596.3 401.2c-14.4 0-26 11.6-26 26v273.4c0 14.4 11.6 26 26 26s26-11.6 26-26V427.2c0-14.4-11.6-26-26-26z",
    className: "delete_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M932.8 190.9H696L635.6 78.4c-4.5-8.4-13.3-13.7-22.9-13.7H413.1c-9.5 0-18.2 5.2-22.8 13.5l-61.8 112.7h-237c-14.4 0-26 11.6-26 26s11.6 26 26 26h79.2v575.2c0 77.1 62.7 139.9 139.9 139.9h403.1c77.2 0 140-62.8 140-140V242.9h79.1c14.4 0 26-11.6 26-26s-11.6-26-26-26zm-504.3-74.2h168.6l39.9 74.2H387.8l40.7-74.2zM801.6 818c0 48.5-39.4 87.9-87.9 87.9H310.6c-48.5 0-87.9-39.4-87.9-87.9V242.9h578.9V818z",
    className: "delete_svg__st0"
  })));
};
export default SvgDelete;